import LayoutCheckbox from 'components/forms/layoutCheckbox';
import LayoutInput from 'components/forms/layoutInput';
import LayoutSelect from 'components/forms/layoutSelect';
import PropTypes from 'prop-types';
import React from 'react';
import ToggleSelect from 'components/forms/ToggleSelect';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {balanceColumns} from 'helpers/fieldHelpers';
import {chemicalBaseTypes, countries, systemTypes, seasonTypes} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';


class WaterProblems extends React.Component {
  static propTypes = {
    analysis: PropTypes.object.isRequired,
    branch: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
    dataChanged: PropTypes.func.isRequired,
    edit: PropTypes.bool.isRequired,
    isType: PropTypes.func.isRequired,
    pool: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    updateFocusElement: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };

  getAlgae = () => {
    let {dealer, analysis} = this.props;
    let algaeProducts = this.getAlgaeProducts();
    let all = [];
    let {formatMessage} = this.props.intl;

    if (this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa) {
      all.push(<LayoutCheckbox label={formatMessage({id: 'preferences.swampy'})}
                               dataKey='swampy'
                               key='swampy'
                               value={analysis.swampy}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      if(!!analysis.swampy) {
        const naturalChemistyEnabled = !!this.props.branch && !!this.props.branch.naturalChemistry;
        let optionsKeys = [];
        let optionsLabels = [];

        if(dealer.country === 'US') {
          optionsKeys = !!this.props.pool.cannotVacToWaste ? [63] : [123];
          optionsLabels = !!this.props.pool.cannotVacToWaste ? ['Pool Tonic'] : ['Power Floc'];
        }

        // Display Pool Complete® 911 as first option for CA & US
        optionsKeys.unshift(223);
        optionsLabels.unshift('Pool Complete® 911');

        if(naturalChemistyEnabled) {
          optionsKeys.push(205);
          optionsLabels.push('Pool First Aid™');
        }

        all.push(<LayoutSelect label={formatMessage({id: 'preferences.swampy.product'})}
                                                       dataKey='swampyProduct'
                                                       key='swampyProduct'
                                                       value={analysis.swampyProduct}
                                                       dataChanged={this.props.dataChanged}
                                                       condition={this.props.isType([1,2, 7, 12, 14])}
                                                       editMode={this.props.edit}
                                                       options={optionsLabels}
                                                       keys={optionsKeys}/>);
      }

      all.push(<LayoutCheckbox label={formatMessage({id: 'general.green.algae'})}
                               dataKey='greenAlgae'
                               key='greenAlgae'
                               value={analysis.greenAlgae}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<LayoutCheckbox label={formatMessage({id: 'general.mustard.algae'})}
                               dataKey='mustardAlgae'
                               key='mustardAlgae'
                               value={analysis.mustardAlgae}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<LayoutCheckbox label={formatMessage({id: 'scan.slime.mold'})}
                               dataKey='slimeMold'
                               key='slimeMold'
                               value={analysis.slimeMold}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);

      all.push(<ToggleSelect label={formatMessage({id: 'general.black.algae'})}
                             dataKey='blackAlgae'
                             key='blackAlgae'
                             value={analysis.blackAlgae}
                             onChange={this.props.dataChanged}
                             options={[formatMessage({id: 'general.light'}), formatMessage({id: 'general.extensive'})]}
                             keys={['1', '2']}/>);

      if(dealer.country !== 'CA') {
        all.push(<LayoutSelect label={formatMessage({id: 'general.algae.product'})}
                               dataKey='algaeProduct'
                               key='algaeProduct'
                               value={analysis.algaeProduct}
                               dataChanged={this.props.dataChanged}
                               condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                               editMode={this.props.edit}
                               options={algaeProducts.options}
                               keys={algaeProducts.keys}/>);
      }
    } else {
      all.push(<LayoutCheckbox label={formatMessage({id: 'general.algae'})}
                               dataKey='spaAlgae'
                               key='spaAlgae'
                               value={analysis.spaAlgae}
                               dataChanged={this.props.dataChanged}
                               editMode={this.props.edit}/>);
    }

    return balanceColumns(all, 3);
  };

  getAlgaeProducts = () => {
    const dealer = this.props.dealer;
    let algaeProducts = {'options': ['Banish®', 'Back Up® 2', 'Spot Kill'], keys: ['40', '39', '101']};

    if (this.props.pool.typeID !== systemTypes.spa) {

      algaeProducts.options.unshift('Algae Complete®');
      algaeProducts.keys.unshift('28');

      if(dealer.country !== countries.CA) {
        algaeProducts.options.unshift('Algae All 60');
        algaeProducts.keys.unshift('33');
      }
    }

    if (this.props.isType([chemicalBaseTypes.saltWaterPool, chemicalBaseTypes.mineralSpringsPool]) && this.props.dealer.saltScapes) {
      algaeProducts.options.push('SaltScapes® Algae Remover');
      algaeProducts.keys.push('78');
    }
    return algaeProducts;
  };

  getCDSection = () => {
    const {dealer, branch, analysis, pool} = this.props;
    let all = [];
    let {formatMessage} = this.props.intl;

    let cdProducts = this.props.pool.typeID === systemTypes.spa ? ['Chlorinating Concentrate'] :
      ['BurnOut 73', 'BurnOut 3', 'Chlorinating Liquid', 'ProGuard', 'Basic Shock', 'Print All'];
    let cdCodes = this.props.pool.typeID === systemTypes.spa ? ['45'] : ['17', '29', '46', '191', '225', '187'];

    if(!branch.proguard || !this.props.isType([1, 2])) {
      //Prevent user choose ProGuard for non halogen and avoid empty cases
      cdProducts = cdProducts.filter(p => p !== 'ProGuard');
      cdCodes = cdCodes.filter(p => p !== '191');
    }

    const basicShockChemicalBaseTypeIDs = [chemicalBaseTypes.chlorinePool, chemicalBaseTypes.mineralSpringsPool, chemicalBaseTypes.saltWaterPool];

    // Filter out basic shock IF:
    if(
      dealer.country !== 'US' || // not US
      pool.typeID !== systemTypes.pool || // not pool
      !basicShockChemicalBaseTypeIDs.includes(pool.chemicalBaseTypeID) // not specified types
    ) {
      cdProducts = cdProducts.filter(p => p !== 'Basic Shock');
      cdCodes = cdCodes.filter(p => p !== '225');
    }

    all.push(<LayoutInput label={formatMessage({id: 'scan.dist.standard'})}
                          dataKey='cDDistStandard'
                          key='cDDistStandard'
                          value={analysis.cDDistStandard}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                          group={this.props.group}
                          validate={val => analysis.chlorineDemandOnly ? !!val && val !== 0 && val >= 0 && val <= 999 : !val || val >= 0 && val <= 999}
                          validateMessage={<FormattedMessage id='scan.validate.dist.standard'/>}/>);

    all.push(<LayoutInput label={formatMessage({id: 'general.sample'})}
                          dataKey='cDSample'
                          key='cDSample'
                          value={analysis.cDSample}
                          group={this.props.group}
                          dataChanged={this.props.dataChanged}
                          editMode={this.props.edit}
                          condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                          validate={
                            val => analysis.chlorineDemandOnly ?
                              !!val && val !== 0 && val >= 0 && val <= 999 &&
                              parseFloat(val || 0) <= parseFloat(analysis.cDDistStandard || 0) :
                              !val || val >= 0 && val <= 999 && parseFloat(val || 0) <= parseFloat(analysis.cDDistStandard || 0)
                          }
                          validateMessage={<FormattedMessage id='scan.validate.sample'/>}/>);

    if (dealer.country === countries.US) {
      all.push(<LayoutSelect label={formatMessage({id: 'general.product'})}
                             dataKey='cDProduct'
                             key='cDProduct'
                             value={analysis.cDProduct}
                             dataChanged={this.props.dataChanged}
                             condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}
                             editMode={this.props.edit}
                             options={cdProducts}
                             keys={cdCodes}/>);
    }

    let setFocusTo = '';
    let numInvalid = 0;

    for (let i = 0; i < all.length; ++i) {
      if (all[i].props.validate && (all[i].props.condition || all[i].props.condition === undefined)) {
        let valid = all[i].props.validate(all[i].props.value);

        if (!valid) {
          if (!setFocusTo) {
            setFocusTo = all[i].props.dataKey;
          }
          numInvalid += 1;
        }
      }
    }

    return [balanceColumns(all, 3), setFocusTo];
  };

  getChlorineDemand = () => {
    let analysis = this.props.analysis;
    let all = [];
    let {formatMessage} = this.props.intl;

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.chlorine.demand.only'})}
                             dataKey='chlorineDemandOnly'
                             key='chlorineDemandOnly'
                             value={analysis.chlorineDemandOnly}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([1, 2, 5, 6, 7, 8, 12, 13, 14, 15])}/>);

    return balanceColumns(all, 3);
  };

  getClarifierDemand = () => {
    let analysis = this.props.analysis;
    let all = [];
    let {formatMessage} = this.props.intl;

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.clarifier.demand'})}
                             dataKey='clarifierDemand'
                             key='clarifierDemand'
                             value={analysis.clarifierDemand}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}/>);

    return balanceColumns(all, 3);
  };

  getSurfaceProblems = () => {
    let analysis = this.props.analysis;
    let all = [];
    let isPool = this.props.pool.typeID === systemTypes.pool;
    let isSpa = this.props.pool.typeID === systemTypes.spa;
    let isSwimSpa = this.props.pool.typeID === systemTypes.swimspa;
    let isSoftSwinPool = this.props.pool.chemicalBaseTypeID === chemicalBaseTypes.softswimPool;

    let {formatMessage} = this.props.intl;

    all.push(<ToggleSelect label={formatMessage({id: 'scan.copper.staining'})}
                           dataKey='copperStaining'
                           key='copperStaining'
                           value={analysis.copperStaining}
                           onChange={this.props.dataChanged}
                           options={[formatMessage({id: 'general.mild'}), formatMessage({id: 'general.severe'})]}
                           keys={['1', '2']}
                           condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.iron.staining'})}
                             dataKey='ironStaining'
                             key='ironStaining'
                             value={analysis.ironStaining}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.unknown.staining'})}
                             dataKey='unknownStaining'
                             key='unknownStaining'
                             value={analysis.unknownStaining}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.scale.buildup'})}
                             dataKey='scaleBuildup'
                             key='scaleBuildup'
                             value={analysis.scaleBuildup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.waterline.buildup'})}
                             dataKey='waterBuildup'
                             key='waterBuildup'
                             value={analysis.waterBuildup}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={isSpa || isPool || isSwimSpa}/>);

    all.push(<LayoutCheckbox label={formatMessage({id: 'scan.organic.staining'})}
                             dataKey='organicStaining'
                             key='organicStaining'
                             value={analysis.organicStaining}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={(isPool || isSwimSpa) && !isSoftSwinPool && this.props.dealer.country === countries.US}/>);


    return balanceColumns(all, 3);
  };

  getWaterClarity = () => {
    const naturalChemistryEnabled = !!this.props.branch && !!this.props.branch.naturalChemistry;
    let {dealer, analysis} = this.props;
    let all = [];
    let {formatMessage} = this.props.intl;

    const cloudyCheckbox = <LayoutCheckbox label={formatMessage({id: this.props.pool.typeID === systemTypes.spa ?
                                                'detailed-report.problems.cloudy' :
                                                'analysis.cloudy.cant.botttom'})}
                                         dataKey='cloudy'
                                         key='cloudy'
                                         value={analysis.cloudy}
                                         dataChanged={this.props.dataChanged}
                                         editMode={this.props.edit}/>;

    all.push(cloudyCheckbox);

    if (analysis.cloudy) {
      const optionsKeys = [223, 63];
      const optionsLabels = ['Pool Complete® 911', 'Pool Tonic'];

      all.pop(); // Removes the checkbox to add it again wrapped in a div and along the select dropdown

      const cloudySelect = <LayoutSelect label={formatMessage({id: 'general.cloudy.product'})}
                                       dataKey='cloudyProductID'
                                       key='cloudyProductID'
                                       value={analysis.cloudyProductID}
                                       dataChanged={this.props.dataChanged}
                                       editMode={this.props.edit}
                                       options={optionsLabels}
                                       keys={optionsKeys}
                                       condition={this.props.pool.typeID === systemTypes.pool && this.props.isType([
                                         chemicalBaseTypes.chlorinePool,
                                         chemicalBaseTypes.brominePool,
                                         chemicalBaseTypes.saltWaterPool,
                                         chemicalBaseTypes.mineralSpringsPool])}/>;

      all.push(<div>
        {cloudyCheckbox}
        {cloudySelect}
      </div>);
    }

    const hazyCheckbox = <LayoutCheckbox label={formatMessage({id: 'general.hazy'})}
                                        dataKey='hazy'
                                        key='hazy'
                                        value={analysis.hazy}
                                        dataChanged={this.props.dataChanged}
                                        condition={this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa}
                                        editMode={this.props.edit}/>;

    all.push(hazyCheckbox);

    if (analysis.hazy) {
      let options = {
        US: {
          keys: [223, 60, 62, 205],
          labels: ['Pool Complete® 911', 'Natural Clarifier','Polysheen Blue','Pool First Aid™'],
        },
        CA: {
          keys: [223, 60, 62, 205],
          labels: ['Pool Complete® 911', 'Natural Clarifier','Polysheen Blue','Pool First Aid™'],
        },
      };

      options = options[dealer.country];

      if (!naturalChemistryEnabled) {
        // remove Pool First Aid™
        options.keys.pop();
        options.labels.pop();
      }

      all.pop(); // Removes the checkbox to add it again wrapped in a div and along the select dropdown

      const hazySelect = <LayoutSelect label={formatMessage({id: 'general.hazy.product'})}
                                      dataKey='clarifier'
                                      key='clarifier'
                                      value={analysis.clarifier}
                                      dataChanged={this.props.dataChanged}
                                      condition={this.props.pool.typeID === systemTypes.pool || this.props.pool.typeID === systemTypes.swimspa}
                                      editMode={this.props.edit}
                                      options={options.labels}
                                      keys={options.keys}/>;

      all.push(
        <div>
          {hazyCheckbox}
          {hazySelect}
        </div>);
    }


    const pollenCheckbox = <LayoutCheckbox label={formatMessage({id: 'customer.water-problems.pollen'})}
                            dataKey='pollen'
                            key='pollen'
                            value={analysis.pollen}
                            dataChanged={this.props.dataChanged}
                            condition={analysis.season !== seasonTypes.closing && analysis.season !== seasonTypes.outSeason &&
                              this.props.pool.typeID === systemTypes.pool && this.props.isType([
                                chemicalBaseTypes.chlorinePool,
                                chemicalBaseTypes.brominePool,
                                chemicalBaseTypes.saltWaterPool,
                                chemicalBaseTypes.mineralSpringsPool,
                                chemicalBaseTypes.softswimPool,
                                chemicalBaseTypes.synergyPool,
                              ])}
                            editMode={this.props.edit}/>;

    all.push(pollenCheckbox);

    if (analysis.pollen) {

      let options = {
        US: {
          keys: [223, 63, 205],
          labels: ['Pool Complete® 911','Pool Tonic', 'Pool First Aid™'],
        },
        CA: {
          keys: [223, 205],
          labels: ['Pool Complete® 911', 'Pool First Aid™'],
        },
      };

      options = options[dealer.country];

      if (!naturalChemistryEnabled) {
        // Remove "Pool First Aid™" if NC products not activated
        options.keys.pop();
        options.labels.pop();
      }

      all.pop(); // Removes the checkbox to add it again wrapped in a div and along the select dropdown

      const pollenSelect = <LayoutSelect label={formatMessage({id: 'general.pollen.product'})}
                              dataKey='pollenProductID'
                              key='pollenProductID'
                              value={analysis.pollenProductID}
                              dataChanged={this.props.dataChanged}
                              editMode={this.props.edit}
                              options={options.labels}
                              condition={analysis.season !== seasonTypes.closing && analysis.season !== seasonTypes.outSeason &&
                              this.props.pool.typeID === systemTypes.pool && this.props.isType([
                                chemicalBaseTypes.chlorinePool,
                                chemicalBaseTypes.brominePool,
                                chemicalBaseTypes.saltWaterPool,
                                chemicalBaseTypes.mineralSpringsPool,
                                chemicalBaseTypes.softswimPool])}
                              keys={options.keys}/>;

      all.push(
        <div>
          {pollenCheckbox}
          {pollenSelect}
        </div>
      );
    }

    all.push(<LayoutCheckbox label={formatMessage({id: 'preferences.foaming'})}
                             dataKey='foaming'
                             key='foaming'
                             value={analysis.foaming}
                             dataChanged={this.props.dataChanged}
                             editMode={this.props.edit}
                             condition={this.props.isType([3, 5, 6, 8, 13, 15])}/>);

    return balanceColumns(all, 3);
  };

  render() {
    let waterClarity = this.props.pool ? this.getWaterClarity() : [];
    let algae = this.props.pool ? this.getAlgae() : [];
    let surfaceProblems = this.props.pool ? this.getSurfaceProblems() : [];
    let chlorineDemand = this.props.pool ? this.getChlorineDemand() : [];
    let clarifierDemand = this.props.pool ? this.getClarifierDemand() : [];
    let [CDSection, focusElement] = this.props.pool ? this.getCDSection() : [];
    let {formatMessage} = this.props.intl;

    this.props.updateFocusElement(focusElement, false);

    return (
      <div className='row'>
        <div className='col-xs-12'>
          <h2>
            <FormattedMessage id="general.water.problems"/>
            <ToolTip title={formatMessage({id: 'scan.completing.section.improves'})}
                     position={tooltipPositions.topRight}
                     iconOnly/>
          </h2>
          <div className='analysis-body'>
            <div className='row'>
              <div className='col-xs-12'>
                <p style={{marginBottom: 15}}><FormattedMessage id="scan.customer.water.look"/></p>
              </div>
            </div>
            <div>
              <label className='shiftRight'><FormattedMessage id="general.water.clarity"/></label>
              {waterClarity}
            </div>
            <hr/>
            <div>
              <label className='shiftRight'><FormattedMessage id="general.algae"/></label>
              {algae}
            </div>
            <hr/>
            <div>
              <label className='shiftRight'><FormattedMessage id="general.surface.problems"/></label>
              {surfaceProblems}
            </div>
            {this.props.isType([1, 2, 5, 6, 7, 12, 13, 14, 15]) ? <div>
              <hr/>
              <div>
                <label className='shiftRight'><FormattedMessage id="preferences.chlorine.demand"/></label>
                {chlorineDemand}
                {CDSection}
              </div>
            </div> : null}
            {this.props.isType([chemicalBaseTypes.softswimPool]) ? <div>
              <hr/>
              {clarifierDemand}
            </div> : null}
          </div>

        </div>
      </div>
    );
  }
}

export default injectIntl(WaterProblems);
